import { useQuery } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchResumeByIdApuracao(id_apuracao?: string) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['resume', id_apuracao],
    queryFn: async () => {
      if (!id_apuracao) throw new Error('ID da apuração não fornecido')

      const response = await api.get(`/resume/${id_apuracao}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Data não encontrado no resultado')
      }
    },
    enabled: Boolean(id_apuracao)
  })
}
